import { Button, CloseButton, Col, Modal, Row } from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import CheckIcon from '@mui/icons-material/CheckCircle';
import Stack from 'react-bootstrap/Stack';
import { STATUSES, DEFAULT_STATE_VALUE,WindowState } from "Utils/constants";
import { PageInfo } from "Components/PageInformation/PageInformation";
import { TextButton } from "Components/Button";


const DynamicFormPopup = ({
    id,
  showPopup,
  handleClose,
  buttons,
  title,
  type,
  disabled,
  children,
  variant,
  size,
  combo, 
  scrollable,
  closeVar
}) => {

  /*const modalBody = (variant) => {
        return (
            <PageInfo 
                type="confirm" 
                message={
                    children
                }
            ></PageInfo>
        );
  }*/

  const modalBody = (variant) => {
    //console.log(variant);
      switch (variant) {
        case "error":
          return (
            
            <PageInfo
                type="error"
                message={
                    children
                }
                combo={combo}
                title={title}
            >
            </PageInfo>

          );
        case "success":
          return (
            <PageInfo
                type="success"
                message={
                    children
                }
                combo={combo}
                title={title}
            ></PageInfo>
            
          );
        case "warning":
          return (
            <PageInfo
                type="warning"
                message={
                    children
                }
                combo={combo}
                title={title}
            ></PageInfo>
          );
        case "batch_error":
          return (
            <PageInfo
                type="batch_error"
                message={
                    children
                }
                combo={combo}
                title={title}
            ></PageInfo>
          );
        case "blank":
            return (
                children
            );
        default:
          return (
            <PageInfo
                type="info"
                message={
                    children
                }
                combo={combo}
                title={title}
            ></PageInfo>
           
          );
      }
    }

  return (
    <>
      <Modal scrollable={scrollable!=null ? scrollable : false} className={"modal " + id!=null ? id : ""} size={size!=null ? size : "lg"} backdrop="static" keyboard={false} show={showPopup} onHide={handleClose}>
        <Modal.Header className={combo!=null ? "mb-3 mb-md-2" : ""}>
          {
            combo!=null 
            ?   null
            :   <Modal.Title >{title}</Modal.Title>
          }
          
          <CloseButton 
            //variant={closeVar!=null ? closeVar : ""} 
            className={"align-self-start " + (closeVar!=null ? ("btn-close-"+closeVar) : "")}
            onClick={handleClose}
          ></CloseButton>
        </Modal.Header>
        <Modal.Body>
          {
            //type!=null 
            //:
                //children
            //: 
            modalBody(variant)
          }
        </Modal.Body>
        <Modal.Footer className={combo!=null ? "mb-3 mb-md-0" : ""}>
            {buttons.map((b, index) => (
                /*<Button key={index} onClick={b.action} variant={b.style=="outline" ? "popup-cancel" : "popup-confirm"} >
                    {b.text}
                </Button>*/
                <TextButton
                    variant={b.variant}
                    onClick={b.action}
                    content={b.text}
                    disabled={b.disabled}
                    size={b.size}
                    className={b.className}
                >

                </TextButton>
            ))}

          
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DynamicFormPopup;